export default __webpack_public_path__ + "static/media/106t.36331bd4.jpg";